// extracted by mini-css-extract-plugin
export var container = "_ho-0";
export var infoIcon = "_ho-2";
export var internalLabel = "_ho-3";
export var titleRowCol = "_ho-1";